// react-grid-layout needs a fixed row height; margins are taken out of the available height first.
// https://github.com/react-grid-layout/react-grid-layout/issues/628#issuecomment-1228453084
export function computeGridRowHeight(availableHeight: number, margin: number, rows: number): number {
    return Math.max(0, Math.floor((availableHeight - margin * rows) / rows));
}
